export default __webpack_public_path__ + "static/media/green-circle-check.f7a55789.svg";